export default "__VITE_ASSET__ClNmRMjw__"